module.exports = __webpack_public_path__ + "media/src/img/payment/submit-hand-79fac9796fe3fd55a4ea274f7b75bc4d.svg";